import { Uuid } from "#customTypes/globalTypes"
import { EnumValues } from "#customTypes/types"

export const STUDENT_TASK_TYPES = {
  PURCHASE: "PURCHASE", // Payment due
  PARENT: "PARENT", // Talk to parent
  SUPPLIES: "SUPPLIES", // Give student supplies
  // Switch class
  OTHER: "OTHER",
} as const

export type StudentTaskType = EnumValues<typeof STUDENT_TASK_TYPES>

/**
 * Display labels for task types. The stored enum values are persisted on
 * student docs and must not change; only these labels are user-facing.
 * `PURCHASE` reads as "Payment Due" (JARVIS-113).
 */
export const STUDENT_TASK_TYPE_LABELS: Record<StudentTaskType, string> = {
  [STUDENT_TASK_TYPES.PURCHASE]: "Payment Due",
  [STUDENT_TASK_TYPES.PARENT]: "Parent",
  [STUDENT_TASK_TYPES.SUPPLIES]: "Supplies",
  [STUDENT_TASK_TYPES.OTHER]: "Other",
}

export const getStudentTaskTypeLabel = (type: StudentTaskType): string =>
  STUDENT_TASK_TYPE_LABELS[type]

export interface StudentTask {
  id: string
  label: string
  type: StudentTaskType
  createdAt: string
  createdBy: Uuid
  isCompleted: boolean
  completedAt: string | null
  completedBy: Uuid | null
}

export type StudentTaskCardData = {
  id: Uuid
  studentId: Uuid
  header: string
  isUrgent: boolean // Is student leaving soon
  tasks: StudentTask[]
  isAllTasksCompleted: boolean
}
